var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#707070",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 2.667c-2.573 0-4.667 2.093-4.667 4.666 0 1.598.806 3.068 2.155 3.932 1.378.883 3.07.977 4.641.254.335-.154.481-.55.327-.885-.153-.334-.55-.48-.884-.327-1.15.53-2.376.469-3.364-.164-.965-.619-1.541-1.669-1.541-2.81C6.667 5.495 8.162 4 10 4s3.333 1.495 3.333 3.333c0 .368-.299.667-.666.667-.336 0-.65-.255-.667-.657v-.01c0-1.102-.897-2-2-2s-2 .898-2 2c0 1.103.897 2 2 2 .512 0 .98-.193 1.333-.51.354.317.822.51 1.334.51 1.102 0 2-.897 2-2 0-2.573-2.094-4.666-4.667-4.666zm.657 4.773c-.051.317-.326.56-.657.56-.368 0-.667-.3-.667-.667 0-.367.3-.666.667-.666.342 0 .624.258.662.59-.01.06-.012.122-.005.183z",
    transform: "translate(-142 -829) translate(140 804) translate(2 25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8.754c0-.172-.07-.344-.195-.47l-2.472-2.471V.667c0-.369-.298-.667-.666-.667H3.333c-.368 0-.666.298-.666.667v5.146L.195 8.284l-.006.007C.064 8.421 0 8.59 0 8.754v12.002c0 1.104.898 2 2 2h16c1.104 0 2-.899 2-2v-12-.002zm-2.667-1.056l1.058 1.058-1.058 1.057V7.698zM4 6.09V1.333h12v9.813l-3.61 3.61H7.61L4 11.146V6.09zM2.667 7.7v2.114L1.609 8.756l1.058-1.058zm-1.334 12.78V10.365l5.058 5.057-5.058 5.057zm.943.943L7.61 16.09h4.782l5.333 5.333H2.276zm16.39-.943l-5.057-5.057 5.058-5.057v10.114z",
    transform: "translate(-142 -829) translate(140 804) translate(2 25)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5c4f691411a9e1afd97c168c37205b69.svg";
export { ForwardRef as ReactComponent };